// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as V2i$Linear from "lumi-linear/lib/es6/src/V2i.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let jsonCodec = Jzon.object3(param => [
  param.topLeft,
  param.bottomLeft,
  param.bottomRight
], param => ({
  TAG: "Ok",
  _0: {
    topLeft: param[0],
    bottomLeft: param[1],
    bottomRight: param[2]
  }
}), Jzon.field("_topLeft", V2i$Linear.jsonCodec), Jzon.field("_bottomLeft", V2i$Linear.jsonCodec), Jzon.field("_bottomRight", V2i$Linear.jsonCodec));

let NNRoi = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object4(param => [
  param.topLeft,
  param.bottomLeft,
  param.bottomRight,
  param.topRight
], param => ({
  TAG: "Ok",
  _0: {
    topLeft: param[0],
    bottomLeft: param[1],
    bottomRight: param[2],
    topRight: param[3]
  }
}), Jzon.field("_topLeft", V2f$Linear.jsonCodec), Jzon.field("_bottomLeft", V2f$Linear.jsonCodec), Jzon.field("_bottomRight", V2f$Linear.jsonCodec), Jzon.field("_topRight", V2f$Linear.jsonCodec));

function points(param) {
  return [
    param.topLeft,
    param.bottomLeft,
    param.bottomRight,
    param.topRight
  ];
}

function NNRoi$NNPolygon(props) {
  let __classList = props.classList;
  let classList = __classList !== undefined ? __classList : [];
  let className = LumiReact.classList([[
      "place-model-nn-polygon",
      true
    ]].concat(classList));
  return JsxRuntime.jsx("g", {
    children: JsxRuntime.jsx("polygon", {
      fill: "none",
      points: points(props.nnPolygon).map(__x => V2$Linear.map(__x, x => x.toString())).map(param => param[0] + `,` + param[1]).join(" "),
      stroke: "orange",
      strokeWidth: "1",
      vectorEffect: "non-scaling-stroke"
    }),
    className: className
  });
}

let NNPolygon = {
  jsonCodec: jsonCodec$1,
  points: points,
  make: NNRoi$NNPolygon
};

export {
  NNRoi,
  NNPolygon,
}
/* jsonCodec Not a pure module */
